export default __webpack_public_path__ + "media/images/borders/black-border-07fed1ef0bd99c3c0c98097b759adb3b.svg";